import React, { Component } from 'react';
import DashboardHeading from './DashboardHeading';
class DashboardPageNotFound extends Component {
  constructor() {
    super();
    this.state = { 
    };
  } 

componentDidMount(){ 

}

 
  render() {
    return (       
        <>  
        <DashboardHeading title="Page not fount"/>
        <div className="col-md-12">
        	<p>Page not fount</p>
        </div>    
        </>     
    );
  }
}

export default DashboardPageNotFound;
